// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Y0lDt","colBig":"styles_colBig__3fZ-w","colSmall":"styles_colSmall__3Hi2L"};